/* eslint no-unused-vars : "off" */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import {Html5QrcodeScanner} from "html5-qrcode";
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';


function QrVerifierModal({
  qrVerifier,
  qrVerifierLoading,
  getTransactionList
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    const qrCodeScanner = new Html5QrcodeScanner(
      'qr-code-reader',
      { fps: 10, qrbox: 250 }
    );

    qrCodeScanner.render((result) => {
      qrVerifier(result, () => {
        setModal({ isOpen: false });
        getTransactionList();
      });
    });

    return () => {
      qrCodeScanner.clear();
    };
  }, []);

  return (
    <Modal.Body>
      <div id="qr-code-reader" />
    </Modal.Body>
  );
}

QrVerifierModal.propTypes = {
  qrVerifier: PropTypes.instanceOf(Function).isRequired,
  qrVerifierLoading: PropTypes.bool.isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }) => ({
  qrVerifierLoading: api.loading.indexOf(c.QR_VERIFIER) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(QrVerifierModal);
